module.exports = __webpack_public_path__ + "img/iGreySvg.0d8bd34b.svg";